import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('content'))
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('title'))
      }, _toDisplayString(_ctx.$t("Обмен")) + " " + _toDisplayString(_ctx.row.currency_from.name.toUpperCase()) + " → " + _toDisplayString(_ctx.row.currency_to.name.toUpperCase()), 3),
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('meta'))
      }, _toDisplayString(_ctx.row.created_at) + " · " + _toDisplayString(_ctx.displayedAmountFrom) + " " + _toDisplayString(_ctx.row.currency_from.name.toUpperCase()), 3)
    ], 2),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.b('status', { [_ctx.statusTone]: true }))
    }, [
      _hoisted_1,
      _createTextVNode(_toDisplayString(_ctx.$t(_ctx.statusLabel)), 1)
    ], 2)
  ], 2))
}